import React from 'react';
import { Input } from '@/components/ui';
import { Form, FormField } from '@/components/business';

export function UserForm ({ form }) {
    return (
        <Form form={form}>
            <FormField name="firstName" label={i18next.t('users.first_name')}
                render={({ field }) => <Input {...field} placeholder={i18next.t('users.first_name')} />}
            />
            <FormField name="lastName" label={i18next.t('users.last_name')}
                render={({ field }) => <Input {...field} placeholder={i18next.t('users.last_name')} />}
            />
            <FormField name="email" label={i18next.t('common.email')}
                render={({ field }) => <Input {...field} placeholder="m@example.com" type="email" />}
            />
            <FormField name="telephone" label={i18next.t('users.telephone_number')}
                render={({ field }) => <Input {...field} type="tel" placeholder="+351 999999999" />}
            />
        </Form>
    );
}
